<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ flowList.QNA_STATUS_NM }}</i>
                    </dt>
                    <dd>
                        <table class="create_table btmLine mt-20">
                            <colgroup>
                                <col width="154px" />
                                <col class="*" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{{ $t('FIELD.SURVEY.FROM') }}</th>
                                    <td>
                                        <em class="space_data">{{ flowList.ANSWERER_NM }}</em>
                                        <em class="space_data">{{ flowList.TEAM_NM }}</em>
                                        <em class="space_data">{{ flowList.DEPT_LEVEL_NM }}</em>
                                        <em class="space_data">{{ flowList.ANSWERER_DEPT_NM }}</em>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('TITLE.POPUP.MESSAGE.DETAIL') }}</th>
                                    <td v-html="getMessage(flowList.MESSAGE)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import ToastGrid from '~c/ToastGrid';

export default {
    name: 'commentPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        param: {},
    },
    data() {
        return {
            pageName: 'commentPopup',
            flowList: [],
        };
    },
    mounted() {
        this.onSearch(this.param);
    },
    methods: {
        onSearch(param) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionDetailFlowInfo.skp`,
                    qs.stringify(param),
                )
                .then(resp => {
                    for (const flow of resp.data.result.rowData) {
                        this.flowList = flow;
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        getMessage(v) {
            if (!SDLUtil.isNull(v)) {
                v = v.replace(/\n/g, '<br />');
            }

            return v;
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/commentPopup.vue